export enum SatoshiOptionEnum {
  'coinanalysis' = 'coinanalysis',
  'rank-risk-analysis' = 'rank-risk-analysis',
  'temporal-profit/loss' = 'temporal-profit/loss',
  'concentrated-losses' = 'concentrated-losses',
  'rising-sectors' = 'rising-sectors',
  'performance-analysis' = 'performance-analysis',
}

export enum SatoshiOptionEnumFormatted {
  'coinanalysis' = 'Análise de Criptomoedas',
  'risk-analysis' = '[Portfólio] - Risco por Ranking',
  'temporal-profit/loss' = '[Portfólio] - Lucro/Prejuízo Temporal',
  'concentrated-losses' = '[Portfólio] - Perdas Concentradas',
  'rising-sectors' = '[Portfólio] - Setores em Alta (Sem Exposição)',
  'performance-analysis' = '[Portfólio] - Desempenho: Tendência',
}
